/* tslint:disable */
/* eslint-disable */
/**
 * The Thing API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum UploadBatchProcessingStatus {
    NotStarted = 0,
    Running = 100,
    Succeeded = 200,
    PartialSuccess = 300,
    Error = 400,
    Deleted = 500
}

export function UploadBatchProcessingStatusFromJSON(json: any): UploadBatchProcessingStatus {
    return UploadBatchProcessingStatusFromJSONTyped(json, false);
}

export function UploadBatchProcessingStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): UploadBatchProcessingStatus {
    return json as UploadBatchProcessingStatus;
}

export function UploadBatchProcessingStatusToJSON(value?: UploadBatchProcessingStatus | null): any {
    return value as any;
}

